import { useState } from 'react';

export default function ApiKeyModal({ onSave, onDismiss }) {
  const [value, setValue] = useState('');
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState(false);

  const handleSave = () => {
    if (!value.startsWith('sk-ant-')) { setError(true); return; }
    setError(false);
    onSave(value.trim());
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
          <div className="modal-tag">{"// LOCAL MODE"}</div>
        <div className="modal-title">Enter your API Key</div>
        <div className="modal-sub">
          Running locally? Paste your Anthropic API key below. It's stored only in
          this browser session and never sent anywhere except directly to Anthropic.
        </div>
        <div className="modal-input-wrap">
          <input
            className="modal-input"
            type={visible ? 'text' : 'password'}
            placeholder="sk-ant-..."
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSave()}
            autoFocus
          />
          <button className="modal-eye" onClick={() => setVisible(!visible)}>
            {visible ? '🙈' : '👁'}
          </button>
        </div>
        {error && <div className="modal-error">Key must start with sk-ant-</div>}
        <div className="modal-btns">
          <button className="modal-save" onClick={handleSave}>SAVE &amp; CONTINUE</button>
          <button className="modal-skip" onClick={onDismiss}>Skip</button>
        </div>
        <div className="modal-footer">
          Get a key at <span>console.anthropic.com</span>
        </div>
      </div>
    </div>
  );
}
